import { render, staticRenderFns } from "./actionmodalwide.vue?vue&type=template&id=0f4a0392&scoped=true&"
import script from "./actionmodalwide.vue?vue&type=script&lang=js&"
export * from "./actionmodalwide.vue?vue&type=script&lang=js&"
import style0 from "./actionmodalwide.vue?vue&type=style&index=0&id=0f4a0392&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4a0392",
  null
  
)

export default component.exports